import React, { useState, useRef, useEffect } from "react";
import "./sidebar.css";
import { Link, useLocation } from "react-router-dom";

function Sidebar() {
    const [open, setOpen] = useState(false);
    // const [active, setActive] = useState("Home");
    const [aboutOpen, setAboutOpen] = useState(false);
    const [appOpen, setAppOpen] = useState(false);

    const sidebarRef = useRef(null);
    const toggleRef = useRef(null);
    const location = useLocation();

    const aboutActive =
        location.pathname === "/product" ||
        location.pathname === "/company";

    const appActive = [
        "/construction-sites",
        "/oil-gas-pro",
        "/airports",
        "/hospitals",
        "/hotels",
        "/traffic-areas",
        "/road-rail-pro",
        "/sports-events",
        "/generator-room"
    ].includes(location.pathname);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                open &&
                sidebarRef.current &&
                !sidebarRef.current.contains(event.target) &&
                toggleRef.current &&
                !toggleRef.current.contains(event.target)
            ) {
                setOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open]);

    return (
        <>
            <div ref={toggleRef} className="mobile-toggle" onClick={() => setOpen(!open)}>
                <i className={`bx ${open ? "bx-x" : "bx-menu"}`}></i>
            </div>
            {open && (
                <div
                    className="overlay"
                    onClick={() => setOpen(false)}
                ></div>
            )}
            <aside ref={sidebarRef} className={`nav ${open ? "show-menu" : ""}`}>
                <nav className="nav-container">

                    <div className="nav-list">

                        <div className="nav-items">
                            <h3 className="nav-subtitle p-2">Menu</h3>

                            <Link to={"/"}
                                className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
                                onClick={() => {
                                    setOpen(false);
                                }}
                            >
                                <i className="bx bx-home nav-icon"></i>
                                <span className="nav-name">Home</span>
                            </Link>

                            <div className="nav-dropdown">
                                <div className={`nav-link nav-parent ${aboutActive ? "active" : ""}`}
                                    onClick={() => setAboutOpen(!aboutOpen)}>
                                    <i className="bx bx-layer nav-icon"></i>
                                    <span className="nav-name">About</span>
                                    <i className={`bx bx-chevron-down nav-dropdown-icon ${aboutOpen ? "rotate" : ""}`}></i>
                                </div>

                                <div className={`nav-dropdown-collapse ${aboutOpen ? "show" : ""}`}>
                                    <Link to="/product" className={`nav-dropdown-item ${location.pathname === "/product" ? "active" : ""}`}
                                        onClick={() => setOpen(false)}
                                    >Product</Link>
                                    <Link to="/company" className={`nav-dropdown-item ${location.pathname === "/company" ? "active" : ""}`}
                                        onClick={() => setOpen(false)}>
                                        Company</Link>
                                </div>
                            </div>

                            <div className="nav-dropdown">
                                <div className={`nav-link nav-parent ${appActive ? "active" : ""}`}
                                    onClick={() => setAppOpen(!appOpen)}>
                                    <i className="bx bx-category nav-icon"></i>
                                    <span className="nav-name">Applications</span>
                                    <i className={`bx bx-chevron-down nav-dropdown-icon ${appOpen ? "rotate" : ""}`}></i>
                                </div>

                                <div className={`nav-dropdown-collapse ${appOpen ? "show" : ""}`}>
                                    <Link to="/construction-sites" className={`nav-dropdown-item ${location.pathname === "/construction-sites" ? "active" : ""}`}
                                        onClick={() => setOpen(false)}>
                                        Construction sites</Link>
                                    <Link to="/oil-gas-pro" className={`nav-dropdown-item ${location.pathname === "/oil-gas-pro" ? "active" : ""}`}
                                        onClick={() => setOpen(false)}>
                                        Oil & Gas projects</Link>
                                    <Link to="/airports" className={`nav-dropdown-item ${location.pathname === "/airports" ? "active" : ""}`}
                                        onClick={() => setOpen(false)}>
                                        Airports</Link>
                                    <Link to="/hospitals" className={`nav-dropdown-item ${location.pathname === "/hospitals" ? "active" : ""}`}
                                        onClick={() => setOpen(false)}>
                                        Hospitals</Link>
                                    <Link to="/hotels" className={`nav-dropdown-item ${location.pathname === "/hotels" ? "active" : ""}`}
                                        onClick={() => setOpen(false)}>
                                        Hotels</Link>
                                    <Link to="/traffic-areas" className={`nav-dropdown-item ${location.pathname === "/traffic-areas" ? "active" : ""}`}
                                        onClick={() => setOpen(false)}>
                                        Traffic areas</Link>
                                    <Link to="/road-rail-pro" className={`nav-dropdown-item ${location.pathname === "/road-rail-pro" ? "active" : ""}`}
                                        onClick={() => setOpen(false)}>
                                        Road & Rail projects</Link>
                                    <Link to="/sports-events" className={`nav-dropdown-item ${location.pathname === "/sports-events" ? "active" : ""}`}
                                        onClick={() => setOpen(false)}>
                                        Sports events</Link>
                                    <Link to="/generator-room" className={`nav-dropdown-item ${location.pathname === "/generator-room" ? "active" : ""}`}
                                        onClick={() => setOpen(false)}>
                                        Generator room projects</Link>
                                </div>
                            </div>

                            <Link to={"/contact"} className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`}
                                onClick={() => setOpen(false)}>
                                <i className="bx bx-phone-call nav-icon"></i>
                                <span className="nav-name">Contact us</span>
                            </Link>
                        </div>

                    </div>
                </nav>
            </aside>
        </>
    );
}

export default Sidebar;
